import { zo, driverDetailsSchema, DriverDetailsSchemaType } from 'remote/global';
import { fileTypeObject } from '../types';

const driverImagesSchema = zo.object({
  attachments: zo.array(fileTypeObject).optional(),
});
type DriverImagesSchemaType = zo.infer<typeof driverImagesSchema>;

const driverDocumentsSchema = zo.object({
  driverCertifications: zo.array(fileTypeObject).optional(),
  driverLicenses: zo.array(fileTypeObject).optional(),
});
type DriverDocumentsSchemaType = zo.infer<typeof driverDocumentsSchema>;

// Let's extract this because it can be different in the future, even though it is not right now
const driverPayloadSchema = driverDetailsSchema;
type DriverPayload = zo.infer<typeof driverPayloadSchema>;

export { driverDetailsSchema, driverImagesSchema, driverDocumentsSchema };
export type {
  DriverDetailsSchemaType,
  DriverImagesSchemaType,
  DriverDocumentsSchemaType,
  DriverPayload,
};
